<template>
    <div class="default-page">

        <div class="buttons">
            <button class="button btn-primary" @click="saveForm">
                {{ $ml.get('buttons.save') }}
            </button>

            <button class="button btn-primary" @click="goToList">
                {{ $ml.get('buttons.back') }}
            </button>

            <button class="button btn-danger"
                    v-if="this.element && this.element.id && getPermissionSection('delete')"
                    @click="openConfirmDelete = true">
                {{ $ml.get('buttons.delete') }}
            </button>

            <button v-for="(button, index) in buttons"
                    :class="['button', button.class]"
                    @click="button.function">
                {{ button.label }}
            </button>
        </div>

        <div class="block" :key="change">
            <div class="title">{{ pageTitle }}</div>
            <div class="body flex-row-wrap">
                <div class="w100">
                    <div class="formBlock">
                        <p class="label">Logo company</p>
                        <div class="flex-row flex-row-image" style="align-items: center;">
                            <div class="avatar image-cover image-cover-top" :style="`flex-shrink:0; background-image: url();`">
                                <img :src="logo_preview.url ? logo_preview.url : '/images/no_image.svg'" alt=""  style="max-width: 400px; max-height: 133px;">
                            </div>
                            <div class="drag-in-drop"
                                 @dragover="dragoverFile"
                                 @dragleave="dragleaveFile"
                                 @drop="(e) => dropFile(e, 'logo')"
                                 @click="$refs.logo.click()">
                                <input type="file"
                                       @change="onChangeFile('logo')"
                                       ref="logo"
                                       accept=".jpeg,.jpg,.png,.gif" />
                                <div class="label">{{ lang.labels.drag_in_drop }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div :class="getClass(label)"
                     v-for="(label, key) in labels">
                    <div class="formBlock">
                        <p :class="['label', {'required' : form_required.includes(label)}]">
                            {{ form_labels[label] }}
                            <template v-if="form_required.includes(label)">*</template>
                        </p>
                        <template v-if="getTypeForm(label) === 'number'">
                            <input type="number"
                                   class="input"
                                   v-model="element[label]"
                                   :placeholder="form_labels[label]">
                        </template>
                        <template v-if="getTypeForm(label) === 'boolean'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    label="title"
                                    v-model="element[label]"
                                    :options="selectBooleanOptions"
                                    :placeholder="form_labels[label]">
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'string'">
                            <div class="input disabled" v-if="element[label]">{{ element[label] }}</div>
                        </template>
                        <template v-if="getTypeForm(label) === 'date'">
                            <date-picker
                                type="datetime"
                                valueType="format"
                                format="MM/DD/YYYY HH:mm"
                                v-model="element[label]"
                                :placeholder="form_labels[label]"
                            />
                            <p class="help">Timezone: America/New York</p>
                        </template>
                        <template v-if="getTypeForm(label) === 'link'">
                            <textarea
                                class="textarea"
                                v-model="element[label]"
                                :placeholder="form_labels[label]">
                            </textarea>
                        </template>
                        <template v-if="getTypeForm(label) === 'textarea'">
                            <textarea
                                class="textarea"
                                v-model="element[label]"
                                :placeholder="form_labels[label]">
                            </textarea>
                        </template>
                        <template v-if="getTypeForm(label) === 'input'">
                            <input type="text"
                                   class="input"
                                   v-model="element[label]"
                                   :placeholder="form_labels[label]">
                        </template>
                        <template v-if="getTypeForm(label) === 'select'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    :label="getSelectLabel(label)"
                                    :value="element[label]"
                                    v-model="element[label]"
                                    :options="dictionaries[label]"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'select-tags'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    label="title"
                                    :multiple="true"
                                    :taggable="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    :value="element[label]"
                                    v-model="element[label]"
                                    :options="dictionaries[label]"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'select-custom'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    label="title"
                                    :multiple="true"
                                    :taggable="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    v-model="element[label]"
                                    :options="dictionaries['categories']"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>


        <ModalWindow :open="openConfirmDelete"
                     @closeModal="openConfirmDelete = false">
            <template slot="title">
                {{ $ml.get('interface.confirm_action') }}
            </template>
            <template slot="body">
                {{ $ml.get('interface.confirm_action_delete') }}
            </template>
            <template slot="buttons">
                <button class="button btn-danger" @click="deleteForm">
                    {{ $ml.get('buttons.delete') }}
                </button>
            </template>
        </ModalWindow>

    </div>
</template>
<script>
import FormDefault from "../../Utils/Page/FormDefault";


export default {
    name: "Form",
    components: {

    },
    mixins: [FormDefault],
    data() {
        return {
            lang: this.$ml.get('pages.company'),
            buttons: [
            ],

            typeForm: {
                user_id: 'select',
                industry_id: 'select',
                logo: 'file',
                email_subscription: 'boolean',
            },

            pageRouteList: 'company',
            pageRouteEdit: 'company.edit',
            pageApi: 'company',
            pagePermission: 'company',

            logo_preview: {
                url: null,
            },
        }
    },
    methods: {
        saveForm() {
            let access = false
            if (this.id) {
                access = this.getPermissionSection('edit')
            } else {
                access = this.getPermissionSection('create')
            }
            if (!access) {
                this.$store.commit('setNotification', {
                    type: 'error',
                    message: 'Permission denied'
                })
                return;
            }


            let data = {
                element: {},
            }

            for (let key in this.element) {
                if (this.form_required.includes(key) && !this.element[key]) {
                    this.$store.commit('setNotification', {
                        type: 'error',
                        message: this.$ml.get('interface.empty_field') + ' - ' + this.lang.form[key]
                    })
                    return
                }

                data.element[key] = this.element[key]
                if (this.selectKeys.includes(this.getTypeForm(key))) {
                    this.getValueSelect(data.element, key)
                }
                if (this.getTypeForm(key) === 'boolean') {
                    if (this.element[key]) {
                        data.element[key] = this.element[key].id
                    }
                }
            }
            let form = new FormData()
            if (this.logo_preview.file) {
                form.append('logo', this.logo_preview.file)
            }
            form.append('element', JSON.stringify(data.element))


            this.$store.commit('setLoading', true)
            axios.post(this.$store.getters.getApiUrl(this.pageApi), form)
                .then(({data}) => {
                    if (data.success) {
                        if (!this.id) {
                            this.id = data.element.id
                            this.$router.push({name: this.pageRouteEdit, params: {id: data.element.id}})
                        }
                        this.getData()
                        this.$store.commit('setNotification', {
                            type: 'success',
                            message: this.$ml.get('interface.saved')
                        })
                    } else {
                        this.$store.commit('setErrorMessage', data.message)
                    }
                })
                .finally(() => {
                    this.$store.commit('setLoading', false)
                })
        },
        setExtraData(data) {
            this.logo_preview.url = data.element.logo
        },
        // Событие при перетаскивании файла
        dragoverFile(event) {
            event.preventDefault();
            event.currentTarget.classList.add('over');
        },
        // Событие при убирании курсора при перетаскивании
        dragleaveFile(event) {
            event.currentTarget.classList.remove('over');
        },
        // Событие добавления файла
        dropFile(event, type) {
            // Снимаем стиль
            event.currentTarget.classList.remove('over')
            event.preventDefault()
            // Помещаем изображение в input
            if (type === 'logo') {
                this.$refs.logo.files = event.dataTransfer.files
            }
            // Вызываем событие изменения
            this.onChangeFile(type)
        },
        // Изменение при добавлении файла
        onChangeFile(type) {
            let files = []
            if (type === 'logo') {
                files = this.$refs.logo.files
            }

            files = Array.from(files)
            files.map(file => {
                if (!this.acceptFile(file, type)) {
                    this.$store.commit('setNotification', {
                        type: 'error',
                        message: this.lang.labels.file_error.replace( /{f}/, file.name)
                    })
                } else {
                    let key = 'upload_' + Math.abs(Math.ceil(Math.random() * (1000 - 9999) + 1000))
                    if (type === 'logo') {
                        let item = {
                            url: '',
                            file: file,
                        }
                        let reader = new FileReader();
                        reader.onload = (e) => {
                            item.url = e.target.result
                        }
                        reader.readAsDataURL(file);
                        this.logo_preview = item
                    }
                }
            })
        },
        acceptFile(file, type) {
            let accept_images = [
                'image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/svg+xml',
            ]
            let accept_document = [
                'image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/svg+xml',
                'application/pdf',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            ];
            if (type === 'logo') {
                if (!accept_images.includes(file.type)) {
                    return false
                }
            } else {
                if (!accept_document.includes(file.type)) {
                    return false
                }
            }
            return true
        },
        getClass(key) {
/*            if (key === 'name') {
                return 'w100'
            }*/
            return 'w33'
        },
    }
}
</script>

<style scoped>

</style>
